module.exports = __webpack_public_path__ + "img/image 23.102ac589.svg";